import { useEffect, useState } from 'react';
import debounce from 'lodash/debounce';

interface State {
  width?: number;
  height?: number;
}

export const RESIZE_DEBOUNCE_TIME = 300;

export const useWindowSize = () => {
  const [windowSize, setWindowSize] = useState<State>({
    width: undefined,
    height: undefined
  });

  useEffect(() => {
    const handleResize = () => {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight
      });
    };

    window.addEventListener('resize', debounce(handleResize, RESIZE_DEBOUNCE_TIME));

    handleResize();

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return windowSize;
};
